import { z } from 'zod';
import { GENDERS } from '../catalog/genders.js';
import { GUEST_OPTIONS } from '../catalog/guestOptions.js';
import { idSchema, nameSchema } from './common.js';
export const guestOptionSchema = z.enum(GUEST_OPTIONS);
export const genderSchema = z.enum(GENDERS);
const idSetSchema = z
    .array(idSchema)
    .max(200)
    .refine((ids) => new Set(ids).size === ids.length, { error: 'Duplicated entry' });
/** A free-form label, lower-cased so "Family" and "family" are the same tag. */
export const tagSchema = z
    .string()
    .trim()
    .min(1, 'Tag cannot be empty')
    .max(30)
    .transform((value) => value.toLowerCase());
const tagSetSchema = z
    .array(tagSchema)
    .max(20)
    .refine((tags) => new Set(tags).size === tags.length, { error: 'Duplicated entry' });
export const createGuestInputSchema = z.strictObject({
    name: nameSchema,
    notes: z.string().trim().max(500).nullish(),
    gender: genderSchema.default('other'),
    options: z.array(guestOptionSchema).default([]),
    /** Guests this one would rather share a room with. */
    roommateIds: idSetSchema.default([]),
    /** Guests this one must never share a room with. */
    incompatibleGuestIds: idSetSchema.default([]),
    /** Rooms this guest must never be placed in. */
    incompatibleRoomIds: idSetSchema.default([]),
    /** Free-form labels for grouping and filtering, e.g. "family", "vegetarian". */
    tags: tagSetSchema.default([]),
});
export const updateGuestInputSchema = z
    .strictObject({
    name: nameSchema,
    notes: z.string().trim().max(500).nullish(),
    gender: genderSchema,
    options: z.array(guestOptionSchema),
    roommateIds: idSetSchema,
    incompatibleGuestIds: idSetSchema,
    incompatibleRoomIds: idSetSchema,
    tags: tagSetSchema,
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    error: 'Provide at least one field to update',
});
//# sourceMappingURL=guests.js.map